module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_8003.0d0dae14.png";